/**
 * Identity server client ID for authentication.
 */
export const IDENTITY_CLIENT_ID = 'SPADev';

/**
 * Name of this app.
 */
export const APP_NAME = 'favorites-provider';

/**
 * Serves as identifier to the root of this SPA in the HTML:
 */
export const ROOT_ELEMENT_ID = `${APP_NAME}-root`;
